<div class="tap-top" *ngIf="showScroll" (click)="onActivate()">
  <div><i class="fa fa-angle-up"></i></div>
</div>
